export default "__VITE_ASSET__psFZHhvo__"